const ProjectCardData = [
  {
    title: 'BFSI Medallion Data Platform',
    category: 'Azure Data Engineering',
    stack: 'ADF, Databricks, ADLS Gen2, PySpark, Delta Lake',
    summary:
      'Built a three-layer Bronze, Silver, and Gold architecture for finance and marketing datasets, moving raw source data into curated analytics-ready tables.',
    highlights: [
      'Implemented watermark and CDC-based incremental processing.',
      'Developed business-driven fact and dimension models.',
      'Added monitoring, reconciliation, and exception handling.'
    ],
    source: 'https://github.com/swapniltake1',
    view: 'https://github.com/swapniltake1'
  },
  {
    title: 'Multi-Source Ingestion Workflows',
    category: 'Data Ingestion',
    stack: 'ADF, SQL Server, Oracle, REST APIs, CSV, JSON',
    summary:
      'Designed reusable ingestion workflows for structured and semi-structured data from five source types, with validation and failure handling built into each flow.',
    highlights: [
      'Parameterized workflows to reduce repeated development effort.',
      'Added logging, auditing, and data quality checks.',
      'Supported reliable downstream reporting datasets.'
    ],
    source: 'https://github.com/swapniltake1',
    view: 'https://github.com/swapniltake1'
  },
  {
    title: 'Performance and Quality Engineering',
    category: 'Optimization',
    stack: 'PySpark, Spark SQL, Python, Delta Lake',
    summary:
      'Applied Spark and SQL optimization patterns alongside validation and reconciliation controls to make production data processing faster and more trustworthy.',
    highlights: [
      'Reduced PySpark processing time by 40%.',
      'Improved reporting performance by 50%.',
      'Supported root-cause analysis and SLA-driven fixes.'
    ],
    source: 'https://github.com/swapniltake1',
    view: 'https://github.com/swapniltake1'
  },
  {
    title: 'Production ETL Operations',
    category: 'Reliability and Support',
    stack: 'Azure DevOps, ADF, Databricks, Synapse',
    summary:
      'Supported scheduled production pipelines from monitoring through troubleshooting, root-cause analysis, deployment coordination, and stakeholder communication.',
    highlights: [
      'Tracked pipeline failures and resolved issues within SLA.',
      'Coordinated fixes and releases through Azure DevOps.',
      'Collaborated with analysts, architects, QA, and business stakeholders.'
    ],
    source: 'https://github.com/swapniltake1',
    view: 'https://github.com/swapniltake1'
  }
];

export default ProjectCardData;
